/**
 * Single source of truth for all overlay routes.
 * NOTICE: Order matters: it defines the deserialization priority (stack bottom → top).
 */
const _ROUTES = {
    cart: {},
    search: {},
    product: {},
    added: {},
    "free-delivery": {},
    "deposit-info": {},
    "service-fee": {},
    "delivery-address": {},
    "restaurant-info": {},
    "menu-cross-selling": {},
    "cart-cross-selling": {},
    "menu-time": {},
    "creator-time": {},
    "cart-time": {},
    "checkout-time": {},
    tip: {},
    stamps: {},
    // Generic Bootstrap modals that run via data-bs-toggle="modal" params
    modal: {},
};
/**
 * All URL param keys managed by the overlay system.
 * Used by OverlayHistorySync to filter non-overlay params when rebuilding URLs.
 */
export const OVERLAY_ROUTE_NAMES = new Set(Object.keys(_ROUTES));
/**
 * Routes that can survive a page refresh (cold hydration from URL).
 */
export const HYDRATABLE_ROUTES = new Set(["product", "cart", "search", "modal"]);
